import { Fragment } from 'react';
import { commitMutation, graphql } from 'react-relay';

import environment from 'src/util/environment';

const mutation = graphql`
  mutation CancelNominatedTradeMutation($id: ID!) {
    cancelNominatedTrade(id: $id) {
      id
      cancelledAt
      cancelledBy {
        id
        email
        givenName
        familyName
      }
    }
  }
`;

/**
 * Cancel nominated trade mutation.
 * @param {object} tradeRuleIdSet Object containing the trade rule id.
 * @param {Function} onCompleted Function to call on success.
 * @param {(error: Error) => void} onError Function to call on error.
 * @param {string|Fragment} formatMessage message to return?
 * @returns {void}
 */
const CancelNominatedTradeMutation = (tradeRuleIdSet, onCompleted, onError, formatMessage) => {
  const { id } = tradeRuleIdSet || {};

  commitMutation(
    environment,
    {
      mutation,
      variables: { id },
      onCompleted: (response) => { onCompleted(response, formatMessage); },
      onError,
      updater: (store) => {
        // Get the current user record from the store
        const ruleProxy = store.get(id);
        ruleProxy.setValue('TRADE_RULE_STATE_CANCELLED', 'state');
      },
    },
  );
};

export default CancelNominatedTradeMutation;
